/**
 * @param {array|object} targetFields the fields array that will be changed.
 * @param {name} name the name of the field that will be remove.
 */

export const excludeDisplayFieldByName = (targetFields, name) => {
  if (!name || !targetFields) return;

  // handle DISPLAY_FIELDS.
  if (Array.isArray(targetFields)) {
    return targetFields.filter(field => field !== name);
  }

  // handle NEXT_FIELD.
  if (typeof targetFields !== 'object') return;

  let resultFields = { ...targetFields };
  const nextFieldValue = resultFields[name];

  const [previousFieldKey] = Object.entries(resultFields).find(
    ([, nextField]) => nextField === name
  );

  delete resultFields[name];

  resultFields[previousFieldKey] = nextFieldValue;
  return resultFields;
};

/**
 * data format might contain {id,name} or {label,value} because of api scheme
 * transform all of them to be the same, for react-select lib
 * @param {id} number
 * @param {name} string
 * @param {value} number
 * @param {label} string
 */
export const transformToOptionFormat = ({
  id,
  name,
  value = id,
  label = name,
} = {}) => {
  if (!value && !label) return;

  return {
    label,
    value,
  };
};



// WEBPACK FOOTER //
// ./app/utils/tutorAuditFields.js